import React from 'react';
import { IFlatEndorsementConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/IFlatEndorsementConfig';
import { Card, Grid } from 'ui-toolkit';
import { TransactionTypesViewer } from '../shared/TransactionTypesViewer';
import { FlatEndorsementFeeViewer } from './FlatEndorsementFeeViewer';
import { ViewerTemplate } from '../ViewerTemplate';
import { eEndorsementNames, TemplateEndorsementsViewer } from './TemplateEndorsementsViewer';

interface IFlatEndorsementsViewerProps {
  flatEndorsements: IFlatEndorsementConfigData[];
}

export const FlatEndorsementsViewer: React.FC<IFlatEndorsementsViewerProps> = ({ flatEndorsements }) => (
  <TemplateEndorsementsViewer endorsementName={eEndorsementNames.Flat} endorsements={flatEndorsements}>
    {flatEndorsements.map((flatEndorsement, index) => (
      <Card
        title={index + 1}
        key={flatEndorsement.endorsements[0].name + flatEndorsement.transactionTypes[0]}
        isCollapsible
      >
        <Grid columnCount={2}>
          <ViewerTemplate viewerName={'Transaction Types'}>
            <TransactionTypesViewer transactionTypes={flatEndorsement.transactionTypes} />
          </ViewerTemplate>
          <ViewerTemplate viewerName={'Flat Endorsement Fees'}>
            <FlatEndorsementFeeViewer endorsements={flatEndorsement.endorsements} />
          </ViewerTemplate>
        </Grid>
      </Card>
    ))}
  </TemplateEndorsementsViewer>
);
